module.exports = __webpack_public_path__ + "img/zhuanye@2x.5246aa18.png";